/**
 * Auth Module
 */
import Vue from 'vue'
import Nprogress from 'nprogress';
import router from '../../../router'
import { getItem, setItem, removeItem } from '@/store/store'

const state = {
    user: getItem('user', null),
    accessToken: getItem('accessToken', null),
    refreshToken: getItem('refreshToken', null)
}

// getters
const getters = {
    user: state => state.user,
    logos: state => state.user.company.partners.map(p => p.logo ? p.logo : p.name),
    isLoggedIn: state => !!state.accessToken,
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken
}

// actions
const actions = {
    signinUserInFirebase(context, payload) {
        const { user } = payload;
        context.commit('loginUser');

    },
    logoutUserFromFirebase(context) {
        Nprogress.start();

    },
    signinUserWithFacebook(context) {
        context.commit('loginUser');

    },
    signinUserWithGoogle(context) {
        context.commit('loginUser');

    },
    signinUserWithTwitter(context) {
        context.commit('loginUser');
        firebase.auth().signInWithPopup(twitterAuthProvider).then((result) => {
            Nprogress.done();
            setTimeout(() => {
                context.commit('loginUserSuccess', result.user);
            }, 500)
        }).catch(error => {
            context.commit('loginUserFailure', error);
        });
    },
    signinUserWithGithub(context) {
        context.commit('loginUser');

    },
    signupUserInFirebase(context, payload) {
        let { userDetail } = payload;
        context.commit('signUpUser');

    },
    signInUserWithAuth0(context, payload) {
        context.commit('signInUserWithAuth0Success', payload);
    },
    signOutUserFromAuth0(context) {
        context.commit('signOutUserFromAuth0Success');
    },
    setUser(context, user) {
        context.commit('user', user)
        context.dispatch('setSeason', { seasonId: user.settings.season })
    },
    setAuthTokens(context, { accessToken, refreshToken }) {
        context.commit('accessToken', accessToken)
        context.commit('refreshToken', refreshToken)
    },
    clearAuth(context) {
        context.commit('clearAuth')
    }
}

// mutations
const mutations = {
    loginUser(state) {
        Nprogress.start();
    },
    loginUserSuccess(state, user) {
        state.user = user;
        localStorage.setItem('user', JSON.stringify(user));
        state.isUserSigninWithAuth0 = false
        router.push("/dashboard");
        setTimeout(function () {
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: 'User Logged In Success!'
            });
        }, 1500);
    },
    loginUserFailure(state, error) {
        Nprogress.done();
        Vue.notify({
            group: 'loggedIn',
            type: 'error',
            text: error.message
        });
    },
    logoutUser(state) {
        state.user = null
        localStorage.removeItem('user');
        router.push("/session/login");
    },
    signUpUser(state) {
        Nprogress.start();
    },
    signUpUserSuccess(state, user) {
        state.user = localStorage.setItem('user', user);
        router.push("/default/dashboard/ecommerce");
        Vue.notify({
            group: 'loggedIn',
            type: 'success',
            text: 'Account Created!'
        });
    },
    signUpUserFailure(state, error) {
        Nprogress.done();
        Vue.notify({
            group: 'loggedIn',
            type: 'error',
            text: error.message
        });
    },
    signInUserWithAuth0Success(state, user) {
        state.user = user;
        localStorage.setItem('user', JSON.stringify(user));
        state.isUserSigninWithAuth0 = true;
    },
    signOutUserFromAuth0Success(state) {
        state.user = null
        localStorage.removeItem('user')
    },
    user(state, user) {
        state.user = user
        setItem('user', user)
    },
    accessToken(state, accessToken) {
        state.accessToken = accessToken
        setItem('accessToken', accessToken)
    },
    refreshToken(state, refreshToken) {
        state.refreshToken = refreshToken
        setItem('refreshToken', refreshToken)
    },
    clearAuth(state) {
        state.user = null
        state.accessToken = null
        state.refreshToken = null
        removeItem('user')
        removeItem('accessToken')
        removeItem('refreshToken')
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
